import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ClientConfigClass;
function ClientConfig() {
  if (ClientConfigClass === VOID) {
    class $ {
      constructor(prereleaseMode, auth0ClientId, auth0Domain, basename, expressEnv, webpackPublicPath, websocketHost) {
        this.j7w_1 = prereleaseMode;
        this.k7w_1 = auth0ClientId;
        this.l7w_1 = auth0Domain;
        this.m7w_1 = basename;
        this.n7w_1 = expressEnv;
        this.o7w_1 = webpackPublicPath;
        this.p7w_1 = websocketHost;
      }
      toString() {
        return 'ClientConfig(prereleaseMode=' + this.j7w_1 + ', auth0ClientId=' + this.k7w_1 + ', auth0Domain=' + this.l7w_1 + ', basename=' + this.m7w_1 + ', expressEnv=' + this.n7w_1 + ', webpackPublicPath=' + this.o7w_1 + ', websocketHost=' + this.p7w_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.j7w_1);
        result = imul(result, 31) + getStringHashCode(this.k7w_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l7w_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.m7w_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.n7w_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o7w_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p7w_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientConfig()))
          return false;
        if (!(this.j7w_1 === other.j7w_1))
          return false;
        if (!(this.k7w_1 === other.k7w_1))
          return false;
        if (!(this.l7w_1 === other.l7w_1))
          return false;
        if (!(this.m7w_1 === other.m7w_1))
          return false;
        if (!(this.n7w_1 === other.n7w_1))
          return false;
        if (!(this.o7w_1 === other.o7w_1))
          return false;
        if (!(this.p7w_1 === other.p7w_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ClientConfig');
    ClientConfigClass = $;
  }
  return ClientConfigClass;
}
//region block: exports
export {
  ClientConfig as ClientConfig2mpft8d5d0hh3,
};
//endregion

//# sourceMappingURL=ClientConfig.mjs.map
